import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";

import upp_flo_haz_lev from "../img/sswpIcons/UpperFloor/upp_flo_haz_lev.png";

import upp_flo_anc_clu from "../img/sswpIcons/UpperFloor/upp_flo_anc_clu.png";
import upp_flo_sla_eye from "../img/sswpIcons/UpperFloor/upp_flo_sla_eye.png";
import upp_flo_cou from "../img/sswpIcons/UpperFloor/upp_flo_blo_cou.png";
import upp_flo_edg_pro from "../img/sswpIcons/UpperFloor/upp_flo_edg_pro.png";
import upp_flo_exc_zon from "../img/sswpIcons/UpperFloor/upp_flo_exc_zon.png";
import upp_flo_fal_arr from "../img/sswpIcons/UpperFloor/upp_flo_fal_arr.png";
import upp_flo_hou from "../img/sswpIcons/UpperFloor/upp_flo_hou.png";
import upp_flo_joi_dec from "../img/sswpIcons/UpperFloor/upp_flo_joi_dec.png";
import upp_flo_lad_acc from "../img/sswpIcons/UpperFloor/upp_flo_lad_acc.png";
import upp_flo_lig from "../img/sswpIcons/UpperFloor/upp_flo_lig.png";
import upp_flo_loa_bay from "../img/sswpIcons/UpperFloor/upp_flo_loa_bay.png";
import upp_flo_oh_wor from "../img/sswpIcons/UpperFloor/upp_flo_oh_wor.png";
import upp_flo_pro from "../img/sswpIcons/UpperFloor/upp_flo_pro.png";
import upp_flo_saf_lad from "../img/sswpIcons/UpperFloor/upp_flo_saf_lad.png";
import upp_flo_sca from "../img/sswpIcons/UpperFloor/upp_flo_sca.png";
import upp_flo_sla_anc from "../img/sswpIcons/UpperFloor/upp_flo_sla_anc.png";
import upp_flo_sta_pro from "../img/sswpIcons/UpperFloor/upp_flo_sta_pro.png";
import upp_flo_tie_lad from "../img/sswpIcons/UpperFloor/upp_flo_tie_lad.png";
import upp_flo_wor_pla from "../img/sswpIcons/UpperFloor/upp_flo_wor_pla.png";
import upp_flo_sit_spe_met from "../img/sswpIcons/UpperFloor/upp_flo_sit_spe_met.png";
import upp_flo_acc_egr from "../img/sswpIcons/UpperFloor/upp_flo_acc_rou.png";
import upp_flo_wor_foo from "../img/sswpIcons/UpperFloor/upp_flo_wor_foo.png";
const json = {
    icon: upp_flo_haz_lev,
    name: "Upper Floor",
    text: "",
    icons: {
        upp_flo_ass_rou: {
            name: "Access/ Egress",
            icon: upp_flo_acc_egr,
            text: (
                <ul>
                    <ListItem text="There must be safe walking routes for workers to/ from/ and within the site" />
                    <ListItem text="There must be safe access using ladders" />
                    <ListItem text="Access to be kept clear from obstruction, materials, and equipment" />
                    <ListItem text="Access should be kept clean and tidy" />
                </ul>
            )
        },
        upp_flo_hou: {
            name: "Housekeeping",
            icon: upp_flo_hou,
            text: (
                <ul>
                    <ListItem text="Accessways must be kept clear of tools, plant, equipment, materials, rubbish or detritus materials/dirt & muck. Bins need to be provided and used." />
                    <ListItem text="Slip, trip and fall hazards need to be removed." />
                    <ListItem text="Protruding nails, screws or other sharp object need to be removed." />
                    <ListItem text="The storage of tools and materials needs to be organised and all operatives need to store items in their designated place." />
                </ul>
            )
        },
        upp_flo_wor_foo: {
            name: "Worker on Foot Routes",
            icon: upp_flo_wor_foo,
            text: (
                <ul>
                    <ListItem text="Workers will be segregated from construction plant." />
                    <ListItem text="If they are in close proximity, barriers will be provided" />
                    <ListItem text="Dedicated and clearly marked routes will be provided" />
                </ul>
            )
        },
        upp_flo_lad_acc: {
            name: "Ladder Access",
            icon: upp_flo_lad_acc,
            text: (
                <ul>
                    <ListItem text="All ladder access must be erected by a person with the relevant mix of training, knowledge and experience." />
                    <ListItem text="The ladder must be free from defects" />
                    <ListItem text="The ladder must be of sufficient length to allow the operative to continue to hold it when reaching the required level/floor." />
                    <ListItem text="The ladder must have secure footing and be tied off." />
                    <ListItem text="Any floor gaps at access points must be sufficiently small to prevent operatives having to cross without having a firm hold on the ladder." />
                </ul>
            )
        },
        upp_flo_saf_lad: {
            name: "Safe Ladder",
            icon: upp_flo_saf_lad,
            text: (
                <ul>
                    <ListItem text="Ladders should NOT be used to carry out works that will be in one position for > 30 minutes. Other methods should be selected." />
                    <ListItem text="All ladders, including step ladders must be checked regularly, be free from defects, and selected, by a competent person, to be suitable for the task." />
                    <ListItem text="The ladder must be of sufficient length to allow the operative to have three points of contact during their activity. Do not use the top three rungs to stand on." />
                    <ListItem text="The ladder must have secure footing and be tied off. The correct angle is 1 (out) in 4 (height)." />
                    <ListItem text="Be aware of, and avoid, electric lines overhead when positioning your ladder. Also avoid loose/ fragile material (such as window panes) at the top contact point" />
                    <ListItem text="Maintain three points of contact, your core should remain inside the stiles, and both feet should be on the same rung" />
                    <ListItem text="Do NOT overreach, and avoid sideways loading." />
                    <ListItem text="Ensure you do not overload the ladder as per the manufacturer’s requirements." />
                </ul>
            )
        },
        upp_flo_tie_lad: {
            name: "Tie Ladder",
            icon: upp_flo_tie_lad,
            text: (
                <ul>
                    <ListItem text="All ladders must be tied or footed to prevent slipping or sliding" />
                    <ListItem text="The tie point must be capable of restraining the ladder." />
                    <ListItem text="Securing at the top is preferred, where it is possible." />
                    <ListItem text="Alternatively, an appropriate ladder stabilizing device, used in accordance with the manufacturer’s instructions, may be used." />
                </ul>
            )
        },
        upp_flo_sca: {
            name: "Scaffold",
            icon: upp_flo_sca,
            text: (
                <ul>
                    <ListItem text="Where possible scaffolds should be used as working platforms when working at height." />
                    <ListItem text="These can only be erected, modified or dismantled by CSCS Basic/ Advanced scaffolding cardholders. " />
                    <ListItem text="You should have a formal handover procedure that both the erector and the user sign-off on suitability of the scaffold. The scaffold must be certified as safe to use." />
                    <ListItem text="Scaffolding must be adequately tied, braced and not overloaded." />
                    <ListItem text="Loading bays must be marked with the safe working load." />
                    <ListItem text="All platforms must be fully boarded, have toe-boards, mid-rails and top guardrails." />
                    <Li>
                        <Typography variant="title">
                            Where a scaffold exceeds 2m in height the scaffold
                            should be inspected weekly by a competent person and
                            should have a weekly GA3 report completed and
                            available on site. The scaffold will have to be
                            inspected by a competent person (who will produce a
                            written inspection report GA3 to be available on
                            site)
                        </Typography>
                        <ol>
                            <ListItem text="At least every 7 days (or after a period without use, before use re-commences)" />
                            <ListItem text="Exposure to bad weather, or" />
                            <ListItem text="Alteration, or" />
                            <ListItem text="Damage, including impact of traffic or site equipment with the scaffold." />
                        </ol>
                    </Li>
                    <ListItem text="If you discover a serious defect you should stop using the scaffold and report it to site management." />
                    <Li>
                        <Typography variant="title">should</Typography>
                        <ol>
                            <ListItem text="know and understand the conditions of use of the scaffold, including the loading capacity" />
                            <ListItem text="NOT overload the scaffold either locally or generally" />
                            <ListItem text="NOT interfere with or misuse the scaffold" />
                            <ListItem text="Promptly report defects in the scaffold to site management" />
                            <ListItem text="NOT leave the scaffold in a hazardous condition for current or subsequent users" />
                        </ol>
                    </Li>
                    <ListItem text="Any modifications (adding to or removing scaffold parts) must be undertaken by CSCS Basic/ Advanced scaffolding cardholders. Guard-rails and toe boards in a single bay may be temporarily removed by persons who have been appropriately instructed. Those persons must remain in attendance at the location of the removed guard-rail or toe-board until it has been replaced." />
                    <ListItem text="The scaffold must have designated access points. Users are not permitted to climb the scaffold structure and must use ladders. Ladders must be secured to the scaffold." />
                    <ListItem text="Materials of equipment must never be thrown or dropped from scaffolding." />
                    <ListItem text="Scaffold platforms must be kept clean and clear of materials with a clear passageway of 430mm for employees to pass." />
                    <ListItem text="Keep the scaffold working platform free from obstacles (e.g. trailing leads or loose materials)" />
                    <ListItem text="Operators can only access the scaffold after each wheel has been locked. The scaffold cannot be moved with operatives or materials on board. You should NOT use mechanical means to push the scaffold." />
                </ul>
            )
        },
        upp_flo_edg_pro: {
            name: "Edge Protection",
            icon: upp_flo_edg_pro,
            text: (
                <ul>
                    <ListItem text="All edges, where there is a risk of operatives falling off must be protected by barriers, handrails, mid-rails, toe-boards etc." />
                    <ListItem text="All edges where there is a risk of materials falling, must be protected using scaffolding/ platforms." />
                </ul>
            )
        },
        upp_flo_wor_pla: {
            name: "Working Platform",
            icon: upp_flo_wor_pla,
            text: (
                <ul>
                    <ListItem text="This is a platform that prevents a worker from falling to a lower level, such as scaffolds, MEWPs etc." />
                    <ListItem text="It must be secure, stable and level" />
                    <ListItem text="The Safe Working Load must be displayed/known, and you are not permitted to overload the platform." />
                    <ListItem text="It must provide safe passage, be large enough to allow the safe use of equipment and materials" />
                    <ListItem text="It must be maintained free from trip hazards, or gaps through which persons or materials could fall, with toe boards and handrails." />
                    <ListItem text="You must maintain the platform in a tidy condition, free from debris." />
                </ul>
            )
        },
        upp_flo_sta_pro: {
            name: "Stair Protection",
            icon: upp_flo_sta_pro,
            text: (
                <ul>
                    <ListItem text="Suitable handrails and barriers must be erected on stair edges and around stair wells. Handrails should be at the appropriate height, have a visual contrast and permit a “power grip”." />
                    <ListItem text="Stairs and stair wells should be adequately lit. Posters, signs and notice boards should NOT be positioned around stairs, as they may cause distraction." />
                    <ListItem text="It is good practice to apply contrasting/high visibility material on step edges." />
                    <ListItem text="Steps should have sufficient grip, and have consistent “going” and “risers”. The “going” should be large enough to place the ball of the foot on the step while descending. If this cannot be achieved, then controls to ensure that workers face the stairs while descending need to be introduced." />
                    <Li>
                        <Typography variant="title">
                            While using stairs you should NOT
                        </Typography>
                        <ol>
                            <ListItem text="Run" />
                            <ListItem text="Have your hands in your pockets" />
                            <ListItem text="Use hand-held devices or phones, or read" />
                            <ListItem text="Use stairs while they are being cleaned" />
                            <ListItem text="Carry open liquids" />
                            <ListItem text="Store items on steps" />
                        </ol>
                    </Li>
                    <ListItem text="You should use the handrails provided" />
                </ul>
            )
        },
        upp_flo_joi_dec: {
            name: "Joist Decking",
            icon: upp_flo_joi_dec,
            text: (
                <ul>
                    <ListItem text="Joists should be fully decked out over the entire working area to prevent falls" />
                </ul>
            )
        },
        upp_flo_oh_wor: {
            name: "Overhead Work",
            icon: upp_flo_oh_wor,
            text: (
                <ul>
                    <ListItem text="Ensure that no work is taking place directly above you" />
                </ul>
            )
        },
        upp_flo_blo_cou: {
            name: "Blockwork Courses",
            icon: upp_flo_cou,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Consider the effect of weather (wind and rain) when
                            building courses
                        </Typography>
                        <ol>
                            <ListItem text="Can blow tools off" />
                            <ListItem text="Wind and rain can effect drying time of mortar creating risk of wall collapse if ignored" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        upp_flo_exc_zon: {
            name: "Exclusion Zone",
            icon: upp_flo_exc_zon,
            text: (
                <ul>
                    <ListItem text="Operatives should not work under an area where loads are being lifted or within the working radii of a job." />
                    <ListItem text="Operatives should keep a safe distance from working plant (at least 2 machine lengths at any time)." />
                    <Li>
                        <Typography variant="title">
                            Operatives on foot must clearly know where such
                            zones are and how they are demarked
                        </Typography>
                        <ListItem text="Barriers" />
                        <ListItem text="Markings/ Signage" />
                        <ListItem text="Method of Work" />
                    </Li>
                </ul>
            )
        },
        upp_flo_lig: {
            name: "Lighting",
            icon: upp_flo_lig,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Adequate lighting levels and consistency must be
                            provided for operative access and work areas. For
                            guidance, minimum levels;
                        </Typography>
                        <ol>
                            <ListItem text="External circulation areas: 10 lx" />
                            <ListItem text="External Material handling areas: 10 lx" />
                            <ListItem text="Internal circulation areas: 5 lx" />
                            <ListItem text="Internal working areas: 15 lx" />
                            <ListItem text="Concreting: 50 lx" />
                            <ListItem text="Carpentry, joinery, blockwork, plastering: 100 lx" />
                            <ListItem text="Painting, decorating: 200 lx" />
                        </ol>
                        <Typography variant="title">
                            Total lumens = area (m2) x level (lx)/0.23
                            (utilisation)
                        </Typography>
                        <Typography variant="title">
                            Number of lights = total lumens/ lumen output of
                            light
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            If using tower lighting
                        </Typography>
                        <ol>
                            <ListItem text="Ensure ground is stable" />
                            <ListItem text="Ensure no contact with overhead lines" />
                            <ListItem text="Only erect tower lighting during daylight" />
                            <ListItem text="Protect from vehicle impact" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Adequate road lamps must be provided at roadworks
                            during hours of darkness in unlit areas{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Steady state lamps along tapers (every 2nd cone)" />
                            <ListItem text="Steady state lamps or rotating reflectors along longitudinal cone runs (every 2nd cone)" />
                            <ListItem text="Flashing lamps are used only at points of danger" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        upp_flo_pro: {
            name: "Propping Work",
            icon: upp_flo_pro,
            text: (
                <ul>
                    <ListItem text="Propping may be needed even in shallow trenches (<1.25m), particularly if ground conditions are particularly poor or the nature of the work requires workers to lie or crouch in the trench." />
                    <ListItem text="Propping with soldier sets is a simple form of trench support set which can be formed with steel or timber. This system is mostly used in rock, stiff clays and in other soil types with similar self-supporting properties. " />
                    <ListItem text="Unlike shoring, soldier sets retain the earth where there may be a fault in the embankment. Soldier sets only provide ground support at regular intervals and do not provide positive ground support to the whole excavated face. Open soldier sets are only suitable for use in stable soil types." />
                    <Li>
                        <Typography variant="title">
                            The following guidelines should be followed
                        </Typography>
                        <ol>
                            <ListItem text="Keep spoil at least 600mm from edge" />
                            <ListItem text="Soldiers (vertical side element) should protrude at least 500mm above top of trench" />
                            <ListItem text="Top Tom (cross-support) should be no lower than 300mm from trench top" />
                            <ListItem text="Maximum spacing between Toms no more than 750mm" />
                            <ListItem text="All jointing should be secured with nails/screws" />
                            <ListItem text="Maximum spacing between Soldiers 1.5m" />
                            <ListItem text="Minimum size of Soldier 150x38mm" />
                            <ListItem text="Minimum size of Tom 150x38mm" />
                            <ListItem text="Tom needs to be long enough to force Soldier firmly against trench side" />
                            <ListItem text="Space between bottom Tom and trench floor should allow for pipe, generally not more than 1m." />
                        </ol>
                    </Li>
                    <ListItem text="Propping can be adaptable, particularly when working around existing services and can be quick to install especially in shallow excavations." />
                    <ListItem text="It requires considerable experience and skill to install, with each arrangement requiring bespoke design." />
                </ul>
            )
        },
        upp_flo_loa_bay: {
            name: "Loading Bay",
            icon: upp_flo_loa_bay,
            text: (
                <ul>
                    <ListItem text="Bay must have necessary load bearing capacity, and be sized to accommodate the required size of loads with sufficient room for safe access and working space. The maximum load bearing capacity should be clearly marked on each loading bay." />
                    <ListItem text="Vehicles should not be required to reverse in areas where workers are on foot, without full segregation (barriers) being in place. Where possible, one-way systems should be used." />
                    <ListItem text="Crossing of the loading bay by workers on foot should be strictly controlled, a safe distance from the loading point, and be directly lit." />
                    <ListItem text="Operatives on foot must wear high visibility PPE, and maintain awareness of their surroundings (not permitted to use mobile devices while in the area)" />
                    <ListItem text="Working platforms must have adequate control measures in place to prevent falls. These areas must be kept clear, and must not be used to store materials." />
                </ul>
            )
        },
        upp_flo_anc_clu: {
            name: "Anchors/ Clutches",
            icon: upp_flo_anc_clu,
            text: (
                <ul>
                    <ListItem text="Ensure that the correct ring clutch has been selected for the anchor and that it is used in accordance with the manufacturers requirements." />
                </ul>
            )
        },
        upp_flo_sla_eye: {
            name: "Casted Slab Eyes",
            icon: upp_flo_sla_eye,
            text: (
                <ul>
                    <ListItem text="Casted Slab Eyes may be used for lift or for aiding fall arrest system (along with safety lines, lanyards etc)" />
                    <ListItem text="Once the slab is installed, these should be removed by cutting to prevent a trip hazard." />
                </ul>
            )
        },
        upp_flo_sla_anc: {
            name: "Slab Anchors",
            icon: upp_flo_sla_anc,
            text: (
                <ul>
                    <ListItem text="All anchors used must be specified by a competent designer." />
                    <ListItem text="Precast floor slabs must be laid in a systematic pattern that facilitates the use of a collective fall protection system." />
                    <ListItem text="You must lay the slabs in accordance with this plan." />
                </ul>
            )
        },

        upp_flo_fal_arr: {
            name: "Fall Arrest and Rescue",
            icon: upp_flo_fal_arr,
            text: (
                <ul>
                    <ListItem text="Cannot be used to replace safe working platforms or safety nets. (Fall restraint)." />
                    <ListItem text="Fall Arrest and Rescue equipment needs to be inspected regularly and visually before each use." />
                    <ListItem text="Operatives must be trained." />
                    <ListItem text="Should be used in connection with a rescue plan. This plan must ensure the operative can be retrieved as soon as possible after the fall and NOT wait on emergency services response. There are 4 classes of rescue, risk assessed for most suitable" />
                <ol>
                <ListItem text="Lowering a remote casualty" />
                <ListItem text="Raising a remote casualty" />
                <ListItem text="Self evacuation by decent" />
                <ListItem text="Resue another in descent (preferably avoided so that other complications are not introduced)" />
                </ol>
                <ListItem text="The rescuer should not endanger themselves when carrying out a rescue procedure " />
                <ol>
                <ListItem text="The anchor must be capable of supporting the load in the required direction." />
                <ListItem text="Ensure proper tie off to anchor points, and re-check before commencing, irrespective of how short the task is going to be." />
                <ListItem text="The harness must be worn fully secured, comfortable but snug and positioned correctly." />
                <ListItem text="All connection systems must have double action, self closing, self locking snap hooks to reduce the possibility of roll out" />
                <ListItem text="Use safety helmets (With chin straps) instead of hard hats." />
                </ol>
                 </ul>

            )
        },
        upp_flo_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: upp_flo_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
